import "expose-loader?jQuery!jquery";
import "expose-loader?$!jquery";
import "signalr";

import { Configuration } from "@/services/Configuration";
import { SignalREvents } from "@/types/types";

export default class SignalRHub {
  private connection!: SignalR.Hub.Connection;

  public hubProxy!: SignalR.Hub.Proxy;

  private signalRStarted: Boolean = false;
  private hubName: string = "ReferralHub";

  private onConnectedHandlers: Array<() => void> = [];
  private onDisconnectedHandlers: Array<() => void> = [];

  constructor() {}

  public startSignalR() {
    console.log(
      `Going to start a SignalR hub connection on url: '${
        Configuration.SignalRUrl
      }' for hub '${this.hubName}'`,
    );

    this.signalRStarted = true;

    this.connection = $.hubConnection(Configuration.SignalRUrl);
    this.hubProxy = this.connection.createHubProxy(this.hubName);

    this.registerOnServerEvents();

    const me = this;

    this.connection
      .start()
      .done(function(data: any) {
        me.handleStarted(data);
      })
      .fail(function(err) {
        me.handleError(err);
      });

    // NOTE: do not make changes to the code below!!!
    this.hubProxy.connection.reconnected(() => {
      // Handle reconnect. The default connection timeout is 30 secs so potentially we have missed a window of 30 secs
      console.log(`SignalR reconnected. Hub: '${me.hubName}'`);

      // SignalR is not available, if we immediately emit connectionEstablished
      setTimeout(() => {
        this.callOnConnectedHandlers();
      }, 2000);
    });

    this.hubProxy.connection.disconnected(function() {
      if (me.signalRStarted) {
        console.log("Disconnected we will try to reconnect");
        setTimeout(function() {
          console.log("Trying to reopen the connection");
          me.connection
            .start()
            .done(function(data: any) {
              me.handleStarted(data);
            })
            .fail(function(err) {
              me.handleError(err);
            });
        }, 5000); // Restart connection after 5 seconds.
      } else {
        console.log(
          `SignalR disconnected from hub connection on url: '${
            Configuration.SignalRUrl
          }' for hub '${me.hubName}'`,
        );
      }

      setTimeout(() => {
        me.onDisconnectedHandlers.forEach(handler => {
          handler();
        });
      }, 2000);
    });
  }

  private callOnConnectedHandlers() {
    this.onConnectedHandlers.forEach(handler => {
      handler();
    });
  }

  public stopSignalR() {
    this.signalRStarted = false;
    this.connection.stop();
    console.log(
      `SignalR Hub stopped, url: '${Configuration.SignalRUrl}', hub: '${
        this.hubName
      }'`,
    );
  }

  public registerOnConnectedHandler(callback: () => void) {
    this.onConnectedHandlers.push(callback);
  }

  public unregisterOnConnectedHandler(callback: () => void) {
    const index = this.onConnectedHandlers.indexOf(callback);
    if (index > -1) {
      this.onConnectedHandlers.splice(index, 1);
    }
  }

  public registerOnDisconnectedHandler(callback: () => void) {
    this.onDisconnectedHandlers.push(callback);
  }

  public unregisterOnDisconnectedHandler(callback: () => void) {
    const index = this.onDisconnectedHandlers.indexOf(callback);
    if (index > -1) {
      this.onDisconnectedHandlers.splice(index, 1);
    }
  }

  private registerOnServerEvents(): void {
    this.hubProxy.on(SignalREvents.UpdatePatientNumber, function(
      fieldEncounterId,
      patientNumber,
    ) {
      console.log(
        `Updating patientnumber for fieldencounter ${fieldEncounterId} to ${patientNumber}`,
      );
    });

    this.hubProxy.on(SignalREvents.AddReferral, function(referral) {
      console.log(`Received new referral ${referral.Reference}`);
    });

    // Websocket connection for updates regarding the manual close of referrals
    this.hubProxy.on(SignalREvents.ManualReferralClose, function(
      fieldEncounterId,
    ) {
      console.log(`Received manual close status of ${fieldEncounterId}`);
    });

    this.hubProxy.on(SignalREvents.ReferralOpened, function(fieldEncounterId) {
      console.log(`Received referral opened for ${fieldEncounterId}`);
    });

    this.hubProxy.on(SignalREvents.UpdateEtaTime, function(
      referenceId: string,
      etaDate: string,
      etaTime: string,
    ) {
      console.log(`Received EtaTime update for referral ${referenceId}: ${etaDate} ${etaTime}`);
    });
  }

  private handleStarted(data: any) {
    let self = this;
    console.log(
      `SignalR Hub connected, url: '${Configuration.SignalRUrl}', hub: '${
        this.hubName
      }' connection id: '${this.connection.id}'`,
    );

    this.hubProxy
      .invoke("listenForReferralUpdates")
      .done(function() {
        console.log("Listening to referral updates");

        // A reconnect within 30 sec passes here...
        self.callOnConnectedHandlers();
      })
      .fail(function(error) {
        console.log(
          "Invocation of listenForReferralUpdates failed. Error: " + error,
        );
      });
  }

  private handleError(err: any) {
    console.log("Error while establishing connection");
    console.log(err);
  }
}
